<template>
  <div class="bt" :class="[searchKey ? `search-students ${innerClass}` : '']">
    <div class="search-con fb fb-col width-full height-full">
      <div class="search-header relative">
        <common-search
          ref="commonSearch"
          :searchKey.sync="searchKey"
          :show-select="showSelect"
          :appoint-role="appointRole"
          :only-class="true"
          :placeholder="placeholder"
        ></common-search>
        <slot name="suffix"></slot>
      </div>
      <div
        v-if="searchKey && !showSlot && !hideSearchList"
        class="item-flex-1 bg-FFFFFF h-0 scroll"
      >
        <div
          v-if="!searchPeopleList.length"
          class="height-full fb fb-cross-center fb-main-center font-34 c-171A1D-40"
          >{{ searchMsg }}</div
        >
        <div v-else>
          <div
            class="bg-FFFFFF pt-10"
            @click="handlerClick(item)"
            v-for="item in searchPeopleList"
            :key="item.studentId"
          >
            <studentHead
              :student-info="item"
              show-all-class
              show-line
              showArrow
              max-width="300"
              showPaddingLeft
            ></studentHead>
          </div>
        </div>
      </div>
      <div v-if="showSlot" class="slot item-flex-1 h-0 scroll">
        <slot name="detail"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import commonSearch from './commonSearch'
import studentHead from './studentHead'
import { mcShowPreloader, mcHidePreloader } from '@/utils/mcSdkUtils'
import { getCombineRole } from '@/utils/comUtils'
import API from '@/api'
import mixin from '../mixin'
export default {
  mixins: [mixin],
  components: { commonSearch, studentHead },
  props: {
    placeholder: {
      type: String,
      default: '学生姓名'
    },
    defaultKey: {
      type: String,
      default: ''
    },
    showNoData: {
      type: Boolean,
      default: true
    },
    liveInOnly: {
      type: Boolean,
      default: false
    },
    // 是否是当前页面的展示
    curPage: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    // 0 德育 1 考评 2 其它
    teacherType: {
      type: Number,
      default: -1
    },
    // 搜索在哪个模块使用  moral-德育、attendance-考勤、dorm-宿舍、opendoor-进出校
    usedModule: {
      type: String,
      required: true
    },
    // 与 usedModule 配合使用，自行调整角色列表范围
    accessList: {
      type: Array,
      default: () => []
    },
    appointRole: {
      type: [Number, String],
      default: 0
    },
    propsDingDeptIds: {
      type: String,
      default: ''
    },
    // 点击完成是否清除数据
    clearOnClick: {
      type: Boolean,
      default: false
    },
    dingDeptIds: {
      type: String,
      default: ''
    },
    innerClass: {
      type: String,
      default: ''
    },
    noHide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      wait: 300, // 防抖时间默认为0.3s
      searchKey: this.defaultKey || '',
      searchPeopleList: [],
      searchMsg: '',
      showSlot: false,
      hideSearchList: false
    }
  },
  watch: {
    searchKey(v) {
      this.$emit('update:searchKey', v)
      this.showSlot = false
      if (v !== '') {
        this.searchDebounce(this.getMembersByKey, this.wait)()
      } else {
        this.searchPeopleList = []
        this.searchMsg = ''
        if (this.curPage) {
          this.$router.back()
        }
      }
    }
  },
  computed: {
    query() {
      return this.$route.query || {}
    },
    roleType() {
      return +this.query.role || this.currentMixinRole
    }
  },
  methods: {
    handlerClick(item) {
      this.$emit('click', item)
      this.clearOnClick && this.clearSearchKey()
      !this.noHide && (this.hideSearchList = true)
    },
    clearSearchKey() {
      try {
        this.$refs.commonSearch.handlerToClearSearchKey()
      } catch (error) {}
    },
    // 搜索
    searchDebounce(func, wait) {
      let _that = this
      // eslint-disable-next-line space-before-function-paren
      return function () {
        let context = this
        let args = arguments
        if (_that.timeout) clearTimeout(_that.timeout)
        _that.timeout = setTimeout(() => {
          func.apply(context, args)
        }, wait)
      }
    },
    // 按名字查询人
    getMembersByKey() {
      if (this.searchKey === '') {
        return
      }
      mcShowPreloader()
      // 对搜索的角色做处理 为 tab 对应的角色
      let _postData = {
        campusId: this.campusId,
        liveInOnly: this.liveInOnly,
        limit: 30,
        q: this.searchKey,
        returnExtFields: [
          'accommodationTagName',
          'className',
          'gender',
          'dormName',
          'deptId'
        ]
      }

      // 合并角色
      _postData.roleTypeList = getCombineRole(
        this.currentRole,
        this.usedModule,
        this.accessList
      )

      if (this.query.dormBuildingIds) {
        _postData.dormBuildingIds = this.query.dormBuildingIds
      }
      // 最后判断是否有外部参数
      const dingDeptIds = this.query.dingDeptIds || this.dingDeptIds
      if (dingDeptIds) {
        _postData.classDingIds = dingDeptIds.split(',')
      }
      // 优先使用props传入的参数
      if (this.propsDingDeptIds) {
        _postData.classDingIds = this.propsDingDeptIds.split(',')
      }
      this.hideSearchList = false
      API.searchByName(_postData)
        .then(res => {
          let _res = res || []
          this.searchMsg = _res.length ? '' : '没有搜索到相关结果'
          this.searchPeopleList =
            (_res.length &&
              _res.map(item => {
                return {
                  id: item.studentDingId,
                  name: item.studentName,
                  gender: item.gender,
                  className: item.className,
                  tagOptionList: item.tagOptionList,
                  dormName: item.dormName,
                  origin: item
                }
              })) ||
            []
          if (this.curPage) {
            this.$emit('clear')
          }
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
        .finally(_ => {
          mcHidePreloader()
        })
    },
    handlerToShowSlot() {
      this.showSlot = true
    }
  },
  mounted() {
    if (this.defaultKey && this.curPage && !this.noHide) {
      this.hideSearchList = true
    }
  }
}
</script>
<style lang="scss" scoped>
.search-students {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
.opendoor {
  position: relative;
}
</style>
